/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/
const CameraIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<path
				style={{
					fill: 'none'
				}}
				d='M82 104.1h24v24H82z'
				transform='translate(-82 -104)'
			/>
			<path
				d='M101.7 113.8c-.5-.2-1-.2-1.4.1l-1.2.9c-.2-1.7-1.6-3-3.3-3h-.1l-2.8-2.8c-.4-.4-.9-.6-1.4-.6H87c-.4 0-.7.3-.7.7s.3.7.7.7h4.5c.2 0 .3.1.5.2l1.8 1.8h-4.1c-1.8 0-3.3 1.5-3.3 3.3v5.4c0 1.8 1.5 3.3 3.3 3.3h6c1.7 0 3.2-1.3 3.3-3l1.2.9c.6.4 1.4.3 1.9-.3.2-.2.3-.5.3-.8V115c0-.5-.3-1-.7-1.2zm-4 6.7c0 1.1-.9 2-2 2h-6c-1.1 0-2-.9-2-2v-5.4c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v5.4zm3.4.2-2-1.5v-2.7l2-1.5v5.7z'
				style={{
					fill: color
				}}
				transform='translate(-82 -104)'
			/>
		</svg>
	)
}

export default CameraIcon
